import DeliveryAreaType from "../types/DeliveryAreaType";
interface DeliveryAreaAction {
  type: string;
  payload?: any;
}
const initial_state = {
  addDeliveryArea: null,
  deliveryAreaList: [],
  currentPage: 0,
  lastPage: 0,
  totalData: 0,
  from: 0,
  to: 0,
  updateDeliveryArea: null,
};
const DeliveryAreaReducer = (
  state = initial_state,
  action: DeliveryAreaAction
) => {
  switch (action.type) {
    case DeliveryAreaType.ADD_DELIVERY_AREA:
      return {
        ...state,
        addDeliveryArea: action.payload,
      };

    case DeliveryAreaType.SET_DELIVERY_AREA_LIST:
      return {
        ...state,
        deliveryAreaList: action.payload.data,
        currentPage: action.payload.currentPage,
        lastPage: action.payload.lastPage,
        totalData: action.payload.totalData,
        from: action.payload.from,
        to: action.payload.to,
      };

    case DeliveryAreaType.UPDATE_DELIVERY_AREA:
      return {
        ...state,
        updateDeliveryArea: action.payload,
      };

    default:
      return state;
  }
};

export default DeliveryAreaReducer;
